<template>
    <module-card :nextDisabled="nextDisabled" ref="moduleCard">
        <p class="text-h6">{{ prompt.text }}</p>
        <div v-for="choice in answerChoices" :key="choice.id" @click.stop="select(choice)" class="grey pa-3 mb-1 response" :class="{ 'lighten-3': !isSelected(choice) }" v-ripple>
            <span :class="{ 'incorrect-selected': isIncorrectAlreadySelected(choice) }">{{ choice.text }}</span>
        </div>
        <slot></slot>
        <ModalFeedback ref="modalFeedback"></ModalFeedback>
    </module-card>
</template>

<script>
    import { shuffle, keyBy, includes, isEqual, sortBy } from 'lodash';

    export default {
        data() {
            return {
                selectedResponseIds: [],
                incorrectSelected: [],
                incorrectMessages: ['Good try, give it another shot', 'Not Quite! Try again', 'Close!'],
                correctFeedback: `You've got it!`,
                choices: [
                    {
                        id: 1,
                        text: `Alcohol`
                    },
                    {
                        id: 2,
                        text: `Pot`
                    },
                    {
                        id: 3,
                        text: `Crystal meth`
                    },
                    {
                        id: 4,
                        text: `Cocaine or Crack`
                    },
                    {
                        id: 5,
                        text: `Poppers`
                    },
                    {
                        id: 6,
                        text: `Viagra® and Cialis®`
                    }
                ],
                prompts: keyBy(
                    [
                        {
                            id: 1,
                            text: `Passed out and don’t know what happened, but now super worried about HIV and STIs!`,
                            choices: [1, 2]
                        },
                        {
                            id: 2,
                            text: `Forget where you put the condoms or whether you brought them!`,
                            choices: [1, 2]
                        },
                        {
                            id: 3,
                            text: `Meant to hook up with one person, but were so amped up that had sex with lots of people`,
                            choices: [3, 4]
                        },
                        {
                            id: 4,
                            text: `Couldn’t get it up, so ruined the moment`,
                            choices: [1, 2]
                        },
                        {
                            id: 5,
                            text: `Had sex more times than you thought you would (or could!) and ran out of condoms`,
                            choices: [3, 5, 6]
                        },
                        {
                            id: 6,
                            text: `Wanted to get your butthole loose before sex, but ended up painful, bleeding and sore`,
                            choices: [5]
                        }
                    ],
                    'id'
                )
            };
        },
        props: {
            promptId: {
                type: Number,
                required: true
            }
        },
        computed: {
            prompt() {
                return this.prompts[this.promptId];
            },
            answerChoices() {
                return shuffle(this.choices);
            }
        },
        methods: {
            nextDisabled() {
                return !isEqual(sortBy(this.selectedResponseIds), sortBy(this.prompt.choices));
            },
            select(choice) {
                if (includes(this.prompt.choices, choice.id)) {
                    // add the choice to the selectedResponseIds if it doesn't already include it
                    if (!includes(this.selectedResponseIds, choice.id)) {
                        this.selectedResponseIds.push(choice.id);
                    }
                    if (!isEqual(sortBy(this.selectedResponseIds), sortBy(this.prompt.choices))) {
                        this.$refs.modalFeedback.show(true, `That's correct! Anything else?`, null);
                    } else {
                        this.$refs.modalFeedback.show(true, this.correctFeedback, () => {
                            this.$refs.moduleCard.nextClick();
                        });
                    }
                } else {
                    // add the choice to incorrectSelected if it doesn't already include it
                    if (!includes(this.incorrectSelected, choice.id)) {
                        this.incorrectSelected.push(choice.id);
                    }

                    this.$refs.modalFeedback.show(false, shuffle(this.incorrectMessages)[0], null);
                }
            },
            isSelected(choice) {
                return includes(this.selectedResponseIds, choice.id);
            },
            isIncorrectAlreadySelected(choice) {
                return this.incorrectSelected.includes(choice.id);
            }
        }
    };
</script>

<style scoped>
    .incorrect-selected {
        text-decoration: line-through;
        text-decoration-color: red;
    }
</style>
